import {useEffect, useRef, useState} from 'react';
import {Modal, Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import MapZonesManager from "./MapZonesManager";
import axiApi from 'ApiCaller';
import {publishEvent} from "core/eventsConnector";
import {ZoneModel} from "./ZoneModels";

const ModalDrawZones = ({show, setShow, zone={...ZoneModel}, subtitle}) => {
    const [assets, setAssets] = useState([]);
    const [zones, setZones] = useState([]);
    const polylines = useRef([])

    useEffect(() => {
        polylines.current = zone.polylines;
        if (show) {
            axiApi.get('/api/assets/zones/')
                .then(response => {
                    setAssets(response.data.items);
                    axiApi.get('/api/distribution/zones/')
                        .then(response => {
                            let _items = response.data.items.filter(item => item.id !== zone.id);
                            setZones(_items);
                        });
                })
        }
    }, [show]);

    const handleClose = () => setShow(false);
    const handleAccept = () => {
        publishEvent("modaldrawmap:zone", polylines.current);
        setShow(false);
    };

    return (
        <Modal show={show} onHide={handleClose} animation={true} scrollable={true} size="xl" aria-modal>
            <Modal.Header closeButton className="preview-canvas mb-0">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="layer-group"/>
                </div>
                <div className="d-inline-flex align-items-center">
                    <Modal.Title className="d-inline-flex ms-3">
                            <div>
                                <div>
                                    Zonas
                                </div>
                                <div>
                                    <small className="h5">{subtitle}</small>
                                </div>
                            </div>
                        </Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body>
                    <MapZonesManager
                        assets={assets}
                        zones={zones}
                        zone={zone}
                        polylines={polylines}
                    />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Descartar
                </Button>
                <Button variant="primary" onClick={handleAccept}>
                    Seleccionar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalDrawZones;